export default __webpack_public_path__ + "static/12-509b8483f8fd863f3fccb5e9414cf740.webp";